export default __webpack_public_path__ + "static/logo-roomcloud-abd93ac010544afe536ba490a56970bc.svg";